import { render, staticRenderFns } from "./TyndallScatteringViz.vue?vue&type=template&id=80f9a27a&scoped=true"
import script from "./TyndallScatteringViz.vue?vue&type=script&lang=js"
export * from "./TyndallScatteringViz.vue?vue&type=script&lang=js"
import style0 from "./TyndallScatteringViz.vue?vue&type=style&index=0&id=80f9a27a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f9a27a",
  null
  
)

export default component.exports